import { Skeleton } from 'antd';

/**
 * Customers list skeleton — 6 ta placeholder row, layout shift'siz.
 */
export default function CustomersSkeleton() {
  return (
    <div
      className="bl-animate-in"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: '12px 16px',
      }}
    >
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 14px',
            borderRadius: 14,
            background: 'var(--bl-surface, #fff)',
            border: '1px solid var(--bl-divider, #ebebeb)',
          }}
        >
          <Skeleton.Avatar active size={42} shape="square" style={{ borderRadius: 13 }} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 5 }}>
            <Skeleton.Input active size="small" style={{ width: 140, height: 14 }} />
            <Skeleton.Input active size="small" style={{ width: 180, height: 11 }} />
          </div>
        </div>
      ))}
    </div>
  );
}
